import { Col, Row } from 'reactstrap';
import { matchesSearch, LookupField, createLookupModel } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import GrauRiscoLookup from 'src/lookups/grau-risco';
import SeveridadeRiscoLookup from 'src/lookups/severidade-risco';
import ProbabilidadeRiscoLookup from 'src/lookups/probabilidade-risco';
import CollapsibleSection from 'src/componentes/CollapsibleSection';

/**
 * Seção de Grau, Severidade e Probabilidade
 */
const RiskAssessmentSection = ({
  model,
  resources,
  intl,
  configuracao,
  searchQuery,
}) => {
  const fields = [
    configuracao?.avaliarRiscoInerente && {
      label: intl.formatMessage({ id: 'labelGrauRiscoInerente' }, { risco: resources.risco }),
      id: 'grausRiscoInerente',
    },
    configuracao?.avaliarRiscoInerente && {
      label: intl.formatMessage({ id: 'labelSeveridadeInerente' }, { severidade: resources.severidade }),
      id: 'severidadeInerente',
    },
    configuracao?.avaliarRiscoInerente && {
      label: intl.formatMessage({ id: 'labelProbabilidadeInerente' }, { probabilidade: resources.probabilidade }),
      id: 'probabilidadeInerente',
    },
    {
      label: intl.formatMessage({ id: 'labelGrauRiscoResidual' }, { risco: resources.risco }),
      id: 'grausRiscoResidual',
    },
    {
      label: intl.formatMessage({ id: 'labelSeveridadeResidual' }, { severidade: resources.severidade }),
      id: 'severidadeResidual',
    },
    {
      label: intl.formatMessage({ id: 'labelProbabilidadeResidual' }, { probabilidade: resources.probabilidade }),
      id: 'probabilidadeResidual',
    },
  ].filter(Boolean);

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;
  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) return null;

  return (
    <CollapsibleSection
      title={intl.formatMessage(
        { id: 'labelGrauSeveridadeProbabilidade' },
        {
          severidade: resources.severidade,
          probabilidade: resources.probabilidade,
        }
      )}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {visibleFields.includes(
          fields.find((f) => f.id === 'grausRiscoInerente')
        ) && (
          <Col md={12}>
            <LookupField
              Component={GrauRiscoLookup}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'labelGrauRiscoInerente' }, { risco: resources.risco }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'labelGrauRiscoInerente' }, { risco: resources.risco }),
                model.getModel('grausRiscoInerente')?.value,
                model.getModel('grausRiscoInerente')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'severidadeInerente')
        ) && (
          <Col md={12}>
            <LookupField
              Component={SeveridadeRiscoLookup}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'labelSeveridadeInerente' }, { severidade: resources.severidade }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'labelSeveridadeInerente' }, { severidade: resources.severidade }),
                model.getModel('severidadeInerente')?.value,
                model.getModel('severidadeInerente')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'probabilidadeInerente')
        ) && (
          <Col md={12}>
            <LookupField
              Component={ProbabilidadeRiscoLookup}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'labelProbabilidadeInerente' }, { probabilidade: resources.probabilidade }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'labelProbabilidadeInerente' }, { probabilidade: resources.probabilidade }),
                model.getModel('probabilidadeInerente')?.value,
                model.getModel('probabilidadeInerente')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'grausRiscoResidual')
        ) && (
          <Col md={12}>
            <LookupField
              Component={GrauRiscoLookup}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'labelGrauRiscoResidual' }, { risco: resources.risco }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'labelGrauRiscoResidual' }, { risco: resources.risco }),
                model.getModel('grausRiscoResidual')?.value,
                model.getModel('grausRiscoResidual')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'severidadeResidual')
        ) && (
          <Col md={12}>
            <LookupField
              Component={SeveridadeRiscoLookup}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'labelSeveridadeResidual' }, { severidade: resources.severidade }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'labelSeveridadeResidual' }, { severidade: resources.severidade }),
                model.getModel('severidadeResidual')?.value,
                model.getModel('severidadeResidual')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'probabilidadeResidual')
        ) && (
          <Col md={12}>
            <LookupField
              Component={ProbabilidadeRiscoLookup}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'labelProbabilidadeResidual' }, { probabilidade: resources.probabilidade }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'labelProbabilidadeResidual' }, { probabilidade: resources.probabilidade }),
                model.getModel('probabilidadeResidual')?.value,
                model.getModel('probabilidadeResidual')?.requestChange
              )}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default RiskAssessmentSection;
